import type { BuyProduct, MBasket } from "@/Models/MBuyPropduct/BuyProduct";
import type { ProductByIdPdp } from "@/Models/MPDP/ProductByIdPDP";

export const mapperToBuyProduct = (
  mDatos: ProductByIdPdp[],
  quantity: number
): BuyProduct | null => {
  if (!mDatos || mDatos.length === 0) return null;
  const {
    Ean,
    Id,
    ListPriceBasket,
    SalesPriceBasket,
    Name,
    CConversionFactor,
    Unit,
    CSalesUnit,
    IsDigital,
    CSaleLimit,
    CCategory,
    CBadges,
    MinOrderQuantity,
    IpClient,
    StepQuantity,
    Price,
  } = mDatos[0] ?? {};

  const basketItem: MBasket = {
    base_price: ListPriceBasket ?? 0,
    cBarcode: Ean ?? "",
    c_conversionFactor: CConversionFactor ?? 0,
    c_fromStoreId: "",
    c_selectedUnit: Unit ?? "",
    c_selesUnit: CSalesUnit ?? "",
    cIsDigital: IsDigital ?? false,
    cSaleLimit: CSaleLimit ?? 0,
    cCategoryId: CCategory ?? "",
    cBadges: CBadges == undefined ? "" : CBadges,
    cMinOrderQuantity: MinOrderQuantity ?? 0,
    inventoryId: "",
    item_id: Id ?? "",
    price: Price ?? 0, //cSalesPrice
    productId: Id ?? "",
    productName: Name ?? "",
    quantity: quantity,
    stepQuantity: StepQuantity ?? 0,
    isDigital: IsDigital ?? false,
    sellLimit: CSaleLimit ?? 0,
    pricePromotion: 10, //xDefecto
    //se agrega la ip del cliente
    salePrice: SalesPriceBasket ?? 0,
    listPrice: ListPriceBasket ?? 0,
    ipAddress: IpClient ?? "",
  };
  
  return {
    skuId: Id ?? "",
    productItems: [basketItem],
  };
};
